import {useEffect} from 'react';
import { Outlet } from 'react-router-dom'
import { BackTop } from 'antd';
import  "./App.less"
import {Header} from "./home/header"
import {Footer} from "./home/footer"
import { useSelector, useDispatch } from 'react-redux';
import { selectLocale } from '../store/localeSlice';
import { setPathNameVal } from '../store/routerSlice';
import {useLocation} from 'react-router-dom';
import ja from '../locale/ja';  
import ko from '../locale/ko';  
import enUS from '../locale/en_us';
import zh from '../locale/zh';
import {IntlProvider} from 'react-intl'

const chooseLocale = (val: string) => { 
    let _val = val || navigator.language.split('_')[0]
    switch (_val) {
      case 'en':
        return enUS
      case 'ja':
        return ja
      case 'ko':
        return ko
      case 'zh':
        return zh
      default:
        return enUS
    }
  }

function App() {
  const location = useLocation();
  const dispatch = useDispatch();
  const isDownloadPage = location.pathname.toLowerCase() === '/download';
  dispatch(setPathNameVal(location.pathname))
  useEffect(() => {
    if (document.body.scrollTop || document.documentElement.scrollTop > 0) {
        window.scrollTo(0, 0)
      }
  }, [location])
  const locale= useSelector(selectLocale);
  return (
    <IntlProvider
      key={locale}
      locale={locale}
      defaultLocale='zh'
      messages={chooseLocale(locale)}
    >
      <div className="App">
        {!isDownloadPage && <Header />}
        <Outlet />
        {!isDownloadPage && <Footer />}
        {/* <FloatButton.BackTop shape="square" style={{fontWeight: 'bold'}} /> */}
        {!isDownloadPage && <BackTop />}
      </div>
    </IntlProvider>
  );
}

export default App;
